import { api } from "@/api/index";
const permission = {
  state: {
    menuTree: [],
    permissions: [],
  },
  mutations: {
    SET_PERMISSION: (state, list) => {
      //放入permissionList存储权限信息
      if (Array.isArray(list)) {
        state.permissions = list
          .filter((i) => {
            return i.id && i.permission;
          })
          .map((i) => i.permission);
      }
    },
    SET_MENUS: (state, list) => {
      if (Array.isArray(list)) {
        state.menuTree = list;
      }
    },
  },
  actions: {
    GET_MENU: async ({ commit, state }, { ...params }) => {
      try {
        let res = await api.menu.getCurrentUserMenu();
        if (res.status && Array.isArray(res.data)) {
          commit("SET_MENUS", res.data);
          commit("SET_PERMISSION", res.data);
        }
      } catch (err) {
        console.log(err, "获取权限异常");
      }
    },
  },
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js